<template>

    <!-- Page Sidebar Ends-->
    <div class="page-body">
        <PageTitle title="Meeting Room Reservation" />

        <div class="container-fluid" v-if="isMobileView()">

            <div class="col-xxl-12">
                <div class="card">
                    <!-- <div class="card-header">
                        <button class="btn btn-secondary" type="button"  @click="meetingroomBook">Reserve Meeting Room</button>
                    </div> -->
                    <div class="card-body">
                        <ul class="nav nav-tabs border-tab border-0 mb-0 nav-danger" id="topline-tab" role="tablist">
                            <li class="nav-item"><a class="nav-link active nav-border pt-0 txt-danger nav-danger"
                                    id="all-gatepass-tab" data-bs-toggle="tab" href="#all-gatepass" role="tab"
                                    aria-controls="all-gatepass" aria-selected="true"><i
                                        class="icofont icofont-man-in-glasses"></i>Schedules</a></li>
                            <li class="nav-item"><a class="nav-link nav-border txt-danger nav-danger" id="requested-tab"
                                    data-bs-toggle="tab" href="#requested" role="tab" aria-controls="requested"
                                    aria-selected="false"><i class="icofont icofont-file-document"></i>All</a>
                            </li>
                            <li><button class="btn btn-primary" type="button" @click="meetingroomBook">ADD</button></li>
                        </ul>
                        
                        <div class="tab-content" id="topline-tabContent">
                            <!-- Active Schedules Card View -->
                            <div class="tab-pane fade show active" id="all-gatepass" role="tabpanel"
                                aria-labelledby="all-gatepass-tab">
                                <div class="card-body px-0 pb-0">
                                    <!-- <div class="col-12 row">
                                        <div class="col-3">
                                            <label class="form-label">From Date</label>
                                            <input class="form-control" type="date" v-model="filter.fromdate"
                                                placeholder="Type Here..." required="">
                                        </div>
                                        <div class="col-3">
                                            <label class="form-label">To Date</label>
                                            <input class="form-control" type="date" v-model="filter.todate"
                                                placeholder="Type Here..." required="">
                                        </div>
                                        <div class="col-3 mt-4">
                                            <button class="btn btn-primary">Filter</button>
                                        </div>
                                    </div> -->
                                    
                                    <div class="user-header pb-2 mt-2">
                                        <h6 class="fw-bold">Active Schedules</h6>
                                    </div>
                                    
                                    <div class="row">
                                        <div class="col-md-4 col-sm-6" v-for="(item, index) in active" :key="item.gatepassid">
                                            <div class="card mb-3">
                                                <div class="card-header text-white"  :class="item.status==2? 'bg-success ': 'bg-primary '">
                                                    <h5 class="text-white">{{ item.room_details }}</h5>
                                                    <small>Booked by: {{ item.emp_name }}</small>
                                                </div>
                                                <div class="card-body">
                                                    <div class="d-flex justify-content-between mb-2">
                                                        <div>
                                                            <strong>Date:</strong><br> {{ item.shedule_date }}
                                                        </div>
                                                        <div>
                                                            <strong>Time:</strong><br> {{ item.shedule_time }} - {{ item.upto_time }}
                                                        </div>
                                                    </div>
                                                    
                                                    <p><strong>Purpose:</strong> {{ item.purpose }}</p>
                                                    <div class="badge text-white"  :class="item.status==2? 'bg-success ': 'bg-primary '">{{item.status==2?'Completed':'On-going'}}</div>
                                                    
                                                    <div class="d-flex justify-content-end" v-if="item.status==1">
                                                        <button class="btn btn-sm btn-success me-2" @click="mettingCompleted(item.id)">
                                                            <i class="icofont icofont-ui-check text-success"></i>Complete
                                                        </button>
                                                        <!--<button class="btn btn-sm btn-warning me-2" @click="">-->
                                                        <!--    <i class="icon-pencil-alt"></i> Edit-->
                                                        <!--</button>-->
                                                        <button class="btn btn-sm btn-danger" @click="removeReservation(item.id)">
                                                            <i class="icon-trash"></i> Delete
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Completed Schedules Card View -->
                            <div class="tab-pane fade" id="requested" role="tabpanel" aria-labelledby="requested-tab">
                                <div class="card-body px-0 pb-0">
                                    <div class="user-header pb-2">
                                        <h6 class="fw-bold">Completed</h6>
                                    </div>
                                    
                                    <div class="row">
                                        <div class="col-md-4 col-sm-6" v-for="(item, index) in completed" :key="item.gatepassid">
                                            <div class="card mb-3">
                                                <div class="card-header text-white" :class="item.status==2? 'bg-success ': 'bg-primary '" >
                                                    <h5 class=" text-white">{{ item.room_details }}</h5>
                                                    <small>Booked by: {{ item.emp_name }}</small>
                                                </div>
                                                <div class="card-body">
                                                    <div class="d-flex justify-content-between mb-2">
                                                        <div>
                                                            <strong>Date:</strong> <br>{{ item.shedule_date }}
                                                        </div>
                                                        <div>
                                                            <strong>Time:</strong> <br>{{ item.shedule_time }} - {{ item.upto_time }}
                                                        </div>
                                                    </div>
                                                    
                                                    <p><strong>Purpose:</strong> {{ item.purpose }}</p>
                                                    <div class="badge text-white"  :class="item.status==2? 'bg-success ': 'bg-primary '">{{item.status==2?'Completed':'On-going'}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Pending Schedules Card View -->
                            <div class="tab-pane fade" id="Pending" role="tabpanel" aria-labelledby="Pending-tab">
                                <div class="card-body px-0 pb-0">
                                    <div class="user-header pb-2">
                                        <h6 class="fw-bold">Pending</h6>
                                    </div>
                                    
                                    <div class="row">
                                        <div class="col-md-4 col-sm-6" v-for="(item, index) in pending" :key="item.gatepassid">
                                            <div class="card mb-3">
                                                <div class="card-header bg-warning text-dark">
                                                    <h5>{{ item.room_details }}</h5>
                                                    <small>Booked by: {{ item.emp_name }}</small>
                                                </div>
                                                <div class="card-body">
                                                    <div class="d-flex justify-content-between mb-2">
                                                        <div>
                                                            <strong>Date:</strong> <br>{{ item.shedule_date }}
                                                        </div>
                                                        <div>
                                                            <strong>Time:</strong> <br>{{ item.shedule_time }} - {{ item.upto_time }}
                                                        </div>
                                                    </div>
                                                    
                                                    <p><strong>Purpose:</strong> {{ item.purpose }}</p>
                                                    
                                                    <div class="d-flex justify-content-end">
                                                        <button class="btn btn-sm btn-success me-2" @click="mettingCompleted(item.id)">
                                                            <i class="icofont icofont-ui-check text-success"></i>Complete
                                                        </button>
                                                        <!--<button class="btn btn-sm btn-warning me-2" @click="">-->
                                                        <!--    <i class="icon-pencil-alt"></i> Edit-->
                                                        <!--</button>-->
                                                        <button class="btn btn-sm btn-danger" @click="removeReservation(item.id)">
                                                            <i class="icon-trash"></i> Delete
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Cancelled Schedules Card View -->
                            <div class="tab-pane fade" id="cancelled" role="tabpanel" aria-labelledby="cancelled-tab">
                                <div class="card-body px-0 pb-0">
                                    <div class="user-header pb-2">
                                        <h6 class="fw-bold">Cancelled</h6>
                                    </div>
                                    
                                    <div class="row">
                                        <div class="col-md-4 col-sm-6" v-for="(item, index) in cancelled" :key="item.gatepassid">
                                            <div class="card mb-3">
                                                <div class="card-header bg-danger text-white">
                                                    <h5>{{ item.room_details }}</h5>
                                                    <small>Booked by: {{ item.emp_name }}</small>
                                                </div>
                                                <div class="card-body">
                                                    <div class="d-flex justify-content-between mb-2">
                                                        <div>
                                                            <strong>Date:</strong> {{ item.shedule_date }}
                                                        </div>
                                                        <div>
                                                            <strong>Time:</strong> {{ item.shedule_time }} - {{ item.upto_time }}
                                                        </div>
                                                    </div>
                                                    
                                                    <p><strong>Purpose:</strong> {{ item.purpose }}</p>
                                                    <div class="badge bg-danger">Cancelled</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div v-else class="container-fluid">

            <div class="col-xxl-12">
                <div class="card">
                    <!-- <div class="card-header">
                        <button class="btn btn-secondary" type="button"  @click="meetingroomBook">Reserve Meeting Room</button>
                    </div> -->
                    <div class="card-body">
                        <ul class="nav nav-tabs border-tab border-0 mb-0 nav-danger" id="topline-tab" role="tablist">
                            <li class="nav-item"><a class="nav-link active nav-border pt-0 txt-danger nav-danger"
                                    id="all-gatepass-tab" data-bs-toggle="tab" href="#all-gatepass" role="tab"
                                    aria-controls="all-gatepass" aria-selected="true"><i
                                        class="icofont icofont-man-in-glasses"></i>Schedules</a></li>
                            <li class="nav-item"><a class="nav-link nav-border txt-danger nav-danger" id="requested-tab"
                                    data-bs-toggle="tab" href="#requested" role="tab" aria-controls="requested"
                                    aria-selected="false"><i class="icofont icofont-file-document"></i>All</a>
                            </li>
                            <!--<li class="nav-item"><a class="nav-link nav-border txt-danger nav-danger" id="Pending-tab"-->
                            <!--        data-bs-toggle="tab" href="#Pending" role="tab" aria-controls="Pending"-->
                            <!--        aria-selected="false"><i class="icofont icofont-file-document"></i>Pending</a>-->
                            <!--</li>-->
                            <!--<li class="nav-item"><a class="nav-link nav-border txt-danger nav-danger" id="cancelled-tab"-->
                            <!--        data-bs-toggle="tab" href="#cancelled" role="tab" aria-controls="Pending"-->
                            <!--        aria-selected="false"><i class="icofont icofont-file-document"></i>Cancelled</a>-->
                            <!--</li>-->
                  
                             <li><button class="btn btn-primary" type="button"  @click="meetingroomBook">Reserve Meeting Room</button></li>

                        </ul>
                        <div class="tab-content" id="topline-tabContent">
                            <div class="tab-pane fade show active" id="all-gatepass" role="tabpanel"
                                aria-labelledby="all-gatepass-tab">
                                <div class="card-body px-0 pb-0">
                           
                                    <div class="user-header pb-2 mt-2">
                                        <h6 class="fw-bold">Active Schedules</h6>
                                    </div>
                                    <div class="user-content">
                                        <div class="table-responsive custom-scrollbar">
                                            <table class="table display " id="Active">
                                                <thead>
                                                    <tr>
                                                        <th>Date</th>
                                                        <th>From Time</th>
                                                        <th>To Time</th>
                                                        <th>User</th>
                                                        <th>Room Details</th>
                                                        <th>Purpose</th>
                                                        <th>Status</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index)  in active" :key="item.gatepassid"  :class="item.status==2? 'lightgreen ': ' '">
                                                        <td>{{ item.shedule_date }}</td>
                                                        <td>{{ item.shedule_time }}</td>
                                                        <td>{{ item.upto_time }}</td>
                                                        <td>{{ item.emp_name }}</td> 
                                                        <td>{{ item.room_details }}</td> 
                                                        <td>{{ item.purpose }}</td> 
                                                        <td>{{item.status==2?'Completed':'On-going'}}</td>  
                                                        <td>
                                                            <ul class="action" v-if="item.status==1">
                                                                <!--<li class="edit" @click=""><i-->
                                                                <!--        class="icon-pencil-alt"></i>-->
                                                                <!--    </li>-->
                                                                <li class="Mark Completed" 
                                                                    @click="mettingCompleted(item.id)"><i  class="icofont icofont-ui-check text-success"></i></li>
                                                                <li class="delete"
                                                                    @click="removeReservation(item.id)"><i
                                                                        class="icon-trash"></i></li>
                                                             
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="requested" role="tabpanel" aria-labelledby="requested-tab">
                                <div class="card-body px-0 pb-0">


                                    <!-- <div class="col-12 row">
                                       
                                       <span class="badge bg-success ms-4 mt-2"  @click="filterlist">Filter</span>
                                               
                                        </div> -->



                                    <div class="user-header pb-2">
                                        <h6 class="fw-bold">All</h6>
                                    </div>
                                    <div class="user-content">
                                        <div class="table-responsive custom-scrollbar">
                                            <table class="table display " id="complete">
                                                <thead>
                                                    <tr>
                                                        <th>Date</th>
                                                        <th>From Time</th>
                                                        <th>To Time</th>
                                                        <th>User</th>
                                                        <th>Room Details</th> 
                                                        <th>Purpose</th>
                                                        <th>Status</th>
                                                        <th>Operation</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index)  in completed" :key="item.gatepassid"  :class="item.status==2? 'lightgreen ': ' '">
                                                        <td>{{ item.shedule_date }}</td>
                                                        <td>{{ item.shedule_time }}</td>
                                                        <td>{{ item.upto_time }}</td>
                                                        <td>{{ item.emp_name }}</td> 
                                                        <td>{{ item.room_details }}</td> 
                                                        <td>{{ item.purpose }}</td> 
                                                        <td>{{item.status==2?'Completed':'On-going'}}</td>  
                                                         <td>
                                                            <ul class="action" v-if="item.status==1">
                                                                <!--<li class="edit" @click=""><i-->
                                                                <!--        class="icon-pencil-alt"></i>-->
                                                                <!--    </li>-->
                                                                <li class="Mark Completed" 
                                                                    @click="mettingCompleted(item.id)"><i  class="icofont icofont-ui-check text-success"></i></li>
                                                                <li class="delete"
                                                                    @click="removeReservation(item.id)"><i
                                                                        class="icon-trash"></i></li>
                                                             
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="Pending" role="tabpanel" aria-labelledby="Pending-tab">
                                <div class="card-body px-0 pb-0">
                                    <div class="user-header pb-2">
                                        <h6 class="fw-bold">Pending</h6>
                                    </div>
                                    <div class="user-content">
                                        <div class="table-responsive custom-scrollbar">
                                            <table class="table display " id="pending">
                                                <thead>
                                                    <tr>
                                                        <th>Date</th>
                                                        <th>From Time</th>
                                                        <th>To Time</th>
                                                        <th>User</th>
                                                        <th>Room Details</th> 
                                                        <th>Purpose</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index)  in pending" :key="item.gatepassid">
                                                        <td>{{ item.shedule_date }}</td>
                                                        <td>{{ item.shedule_time }}</td>
                                                        <td>{{ item.upto_time }}</td>
                                                        <td>{{ item.emp_name }}</td> 
                                                        <td>{{ item.room_details }}</td> 
                                                        <td>{{ item.purpose }}</td> 
                                                         <td>
                                                            <ul class="action">
                                                                <!--<li class="edit" @click=""><i-->
                                                                <!--        class="icon-pencil-alt"></i></li>-->
                                                                <li class="Mark Completed"
                                                                    @click="mettingCompleted(item.id)"><i
                                                                        class="icofont icofont-ui-check text-success"></i></li>
                                                                <li class="delete"
                                                                    @click="removeReservation(item.id)"><i
                                                                        class="icon-trash"></i></li>
                                                             
                                                            </ul>
                                                        </td>
                                                       
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="cancelled" role="tabpanel" aria-labelledby="cancelled-tab">
                                <div class="card-body px-0 pb-0">
                                    <div class="user-header pb-2">
                                        <h6 class="fw-bold">Cancelled</h6>
                                    </div>
                                    <div class="user-content">
                                        <div class="table-responsive custom-scrollbar">
                                            <table class="table display " id="cancelledTable">
                                                <thead>
                                                    <tr>
                                                        <th>Date</th>
                                                        <th>From Time</th>
                                                        <th>To Time</th>
                                                        <th>User</th>
                                                        <th>Room Details</th> 
                                                        <th>Purpose</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index)  in cancelled" :key="item.gatepassid">
                                                        <td>{{ item.shedule_date }}</td>
                                                        <td>{{ item.shedule_time }}</td>
                                                        <td>{{ item.upto_time }}</td>
                                                        <td>{{ item.emp_name }}</td> 
                                                        <td>{{ item.room_details }}</td> 
                                                        <td>{{ item.purpose }}</td> 
                                                       
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- footer   start-->
    <div class="modal fade" id="meetingroomBookHere" tabindex="-1" role="dialog" aria-labelledby="meetingroomBookHere"
        aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Reserve Meeting Room</h4>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="modal-toggle-wrapper ">
                                <div class="col-md-12 position-relative">
                                    <label class="form-label">Meeting Purpose</label>
                                    <input class="form-control" type="text" v-model="selected_room.purpose" placeholder="Type Here..." required="">
                                </div>  
                                <div class="row">
                                <div class="col-md-4 col-12">
                                    <label class="form-label">Schedule Date</label>
                                    <input class="form-control" type="date" v-model="selected_room.schedule_date">
                                    </div> 
                                    <div class="col-md-4 col-12">
                                        <label class="form-label">From Time</label>
                                    <input class="form-control" type="time" v-model="selected_room.schedule_time">
                                    </div> 
                                    <div class="col-md-4 col-12">
                                        <label class="form-label">To Time</label>
                                    <input class="form-control" type="time" v-model="selected_room.upto_time">
                                    </div>
                                </div>
                        <br>
                        <div class="col-sm-12">
                            <div class="row g-3">

                             
                                <div class="col-md-2 col-4 position-relative "  v-for="(item, index)  in rooms" :key="item.id" @click="show_booking(item.id)">
                                    <div :class="`${selected_room.roomid==item.id ? 'card bg-danger' : 'card bg-success'}`"  @click="select_room(item.id)">
                                        <div :class="`${selected_room.roomid==item.id ? 'card-body bg-danger' : 'card-body bg-success'}`" >
                                            <label class="form-label text-white">{{item.roomname}}</label>
                                        </div> 
                                    </div>
                                </div>


                                
                            </div>
                        </div>

                        <div>

                         <div v-if="rooms.length > 0">

                            <div v-if="bookinginfo.length > 0" >

                                   <table class="table" >
                                        <tr class="bg-info text-center">
                                            <td class=" text-white ">From</td>
                                            <td class=" text-white ">To</td>
                                            <td class=" text-white ">Staff Name</td>
                                            <td class=" text-white ">Status</td>
                                        </tr>
                                        <tr  v-for="(item, index) in bookinginfo" :key="index" class=" text-center  text-danger">
                                            <td>{{ item.shedule_time }}</td>
                                            <td>{{ item.upto_time }}</td>
                                            <td>{{ item.emp_name }}</td>
                                            <td>{{ item.status==1 ? 'Booked':'Available' }}</td>
                                        </tr>
                                    </table>

                            </div>
                            <div v-else>
                                <span><strong>Available Booking</strong></span>
                              </div>


                              </div>
                              <div v-else>
                                <span class="text-danger"><strong>Please Create Room</strong></span>
                                </div>

                        </div>
                          





                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-12">
                        <div class="row">
                            

                            <div class="col-md-5 col-12">
                                <button class="btn btn-sm btn-primary" @click="reserve_room" v-if="rooms.length>0">Reserve Meeting Room</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


<!-- start Model -->
<div class="modal" v-if="showfilterModel" style="display: block; background-color: rgba(0,0,0,0.5);" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Filter</h5>
          <button type="button" class="close" @click="showfilterModel = false" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">

            <div class="col-12 row" >


                <div class="col-6">
                <label class="form-label">From Date</label>
                <input class="form-control" type="date" 
                    v-model="filter.fromdate" placeholder="Type Here..." required>
                </div>

                <div class="col-6">
                    <label class="form-label">To Date</label>
                    <input class="form-control" type="date" 
                        v-model="filter.todate" placeholder="Type Here..." required>
                    </div>
                </div>

                <div class="col-12 row" >

      
                        <label class="form-label">Department Name</label>   
                        <Autocomplete 
                              :items="departments"
                              labelField="deptname" 
                              valueField="id"
                              placeholder="Search Department"
                              @select="handleSelectDept" />
                            </div>      

        </div>
        <div class="modal-footer">
        
          <button type="button" class="btn btn-primary" @click="getfilterlist">Filter</button>
        </div>
      </div>
    </div>
  </div>
 <!-- end Model -->






























    <ModalsPart v-if="!['login'].includes($route.name)" @getGatePassData="updateData" />
</template>
<style scoped>
.avatar {
    width: 50px;
    border-radius: 30px;
}
.lightgreen{
 background: #c0ffbe;   
}
</style>
<script>
// @ is an alias to /src 
import PageTitle from '@/components/PageTitle.vue';
import ModalsPart from '@/components/Modals.vue';
import GatePass from '@/components/GatepassPrint.vue';
// import axios from 'axios';
import axios from "@/plugins/axios";

export default {
    name: 'MeetingRoomBook',
    components: {
        PageTitle, ModalsPart,GatePass
    }, mounted() {
        this.getBasics();

    }, data() {
        return { 
            filter:{
                fromdate:this.todayDate(),
                todate:this.todayDate(),
              
            },
            cancelled: [],
            showfilterModel:false,
            completed: [],
            bookinginfo:[],
            active: [],
            rooms:[], 
            pending:[], 
            departments:[],
            selected_room:{'roomid':0,'schedule_date':'','schedule_time':'','purpose':'','upto_time':''}
        }
    },
    methods: {
        
        select_room(roomid){
            this.selected_room.roomid=roomid; 
        },
        meetingroomBook() {
                    var today = new Date();
                    var month=today.getMonth()+1;
                    this.selected_room.schedule_date = today.getFullYear()+'-'+((month<10)?'0'+(month):month)+'-'+((today.getDate()<10)?'0'+today.getDate():today.getDate());//today.getDate();;
                    this.selected_room.schedule_time  = ((today.getHours()<10)?'0'+today.getHours():today.getHours()) + ":" +((today.getMinutes()<10)?'0'+today.getMinutes():today.getMinutes());// today.getMinutes() ;
    
            $("#meetingroomBookHere").modal("show");

        }, 
        getBasics() {
            var self = this;
            axios.post('getRoomReservation').then(function (response) { 
                self.active = response.data.active;
                self.completed = response.data.completed;
                self.cancelled = response.data.cancelled;
                self.rooms = response.data.rooms;
                self.pending = response.data.pending;
                self.departments = response.data.departments;
                window.scrollTo(0, 0);
            }).then(() => {
                self.refreshTable();
            });
        },
        removeReservation(id) {
            var self = this;
            self.$swal({
                title: "Do You Want To Delete?",
                text: "Are you sure? You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes, Delete it!"
            }).then((result) => { // <--
                if (result.value) { // <-- if confirmed
                    axios.post('removeReservation', { id: id }).then(function (response) {
                        self.destroyTable();
                                self.active = response.data.active;
                                self.completed = response.data.completed;
                                self.cancelled = response.data.cancelled;
                                self.rooms = response.data.rooms;
                                self.pending = response.data.pending;
                        window.scrollTo(0, 0);
                    }).then(() => {
                                self.refreshTable();


                            });
                }
            });

        },
         
        mettingCompleted(id) {
            var self = this;
            self.$swal({
                title: "Do You Want To Proceed?",
                text: "Confirm that, Your Meeting is Done ?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes, Done"
            }).then((result) => { // <--
                if (result.value) { // <-- if confirmed
                    axios.post('mettingCompleted', { id: id }).then(function (response) {
                        self.destroyTable();
                                self.active = response.data.active;
                                self.completed = response.data.completed;
                                self.cancelled = response.data.cancelled;
                                self.rooms = response.data.rooms;
                                self.pending = response.data.pending;
                        window.scrollTo(0, 0);
                    }).then(() => {
                                self.refreshTable();


                            });
                }
            });

        },
        reserve_room(visit) {
            var self = this;
         if(!self.selected_room.purpose){
            self.$swal("Enter Meeting Purpose");
         }else{


            self.$swal({
                title: "Do You Want To Book?",
                text: "Just For Confirmation !",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes"
            }).then((result) => { // <--
                if (result.value) { // <-- if confirmed
                    axios.post('bookEmpMeetingRoom', { selected_room: this.selected_room }).then(function (response) {
                        self.destroyTable();
                        if(response.data.is==1){
                            $("#meetingroomBookHere").modal("toggle");                 
                                self.active = response.data.active;
                                self.completed = response.data.completed;
                                self.cancelled = response.data.cancelled;
                                self.rooms = response.data.rooms;
                                self.pending = response.data.pending;
                                self.selected_room={'roomid':0,'schedule_date':'','schedule_time':'','purpose':''};
                        }
                        self.$swal(response.data.msg);

                        
                    }).then(() => {
                                self.refreshTable();


                            });
                }
            });
        }

        },
        getImageUrl(image) {
            return `${this.$hostname}/writable/visitors/${image}`;
        },


        show_booking(id) {
            var self = this;
            axios.post('getRoomReservationinfo',{id:id,schedule_date:self.selected_room.schedule_date}).then(function (response) { 
                self.destroyTable();
                self.bookinginfo = response.data.bookinginfo;

                window.scrollTo(0, 0);
            }).then(() => {
                                self.refreshTable();


                            });


},



destroyTable(){
                if ($.fn.dataTable.isDataTable('#Active')) {
                                    $('#Active').DataTable().destroy();
                                }
                if ($.fn.dataTable.isDataTable('#complete')) {
                                    $('#complete').DataTable().destroy();
                                }
                if ($.fn.dataTable.isDataTable('#pending')) {
                                    $('#pending').DataTable().destroy();
                                }
                if ($.fn.dataTable.isDataTable('#cancelledTable')) {
                                    $('#cancelledTable').DataTable().destroy();
                                }
            },
    refreshTable(){
        var self=this;
                    $("#Active").DataTable({
                        dom: 'Bfrtip',
                        buttons: ['excel', 'pdf'],
                        "paging": true,
                        "ordering": true,
                        "autoWidth": false
                    });
                    
                    $("#complete").DataTable({
                        dom: 'Bfrtip',
                        buttons: ['excel', 'pdf',{
                                                text: 'Filter',
                                                action: function (e, dt, node, config) {
                                                  self.filterlist();
                                                }}],
                        "paging": true,
                        "ordering": true,
                        "autoWidth": false
                    });
                    $("#pending").DataTable({
                        dom: 'Bfrtip',
                        buttons: ['excel', 'pdf'],
                        "paging": true,
                        "ordering": true,
                        "autoWidth": false
                    });
                    $("#cancelledTable").DataTable({
                        dom: 'Bfrtip',
                        buttons: ['excel', 'pdf'],
                        "paging": true,
                        "ordering": true,
                        "autoWidth": false
                    });
    },


    todayDate() {
                var today = new Date();
                var month = today.getMonth() + 1;

                return today.getFullYear() + '-' + ((month < 10) ? '0' + month : month) + '-' + ((today.getDate() < 10) ? '0' + today.getDate() : today.getDate());//today.getDate();;

            },

            isMobileView() {
      if (window.innerWidth <= 768) {
        //   alert("Yes");
        return true;
        } else {
            // alert("No");
          return false;
        }
      },



      filterlist(){


            this.showfilterModel=true;
            this.filter.id=0;


        },


        getfilterlist() {
            var self = this;
            axios.post('filterRoomReservation',self.filter).then(function (response) { 
                self.destroyTable();
                self.completed = response.data.completed;
                self.rooms = response.data.rooms;
                self.status = response.data.status;

                if(self.status == 1){
                    self.$swal("Filtered");
                    self.showfilterModel=false;
                }

                // self.active = response.data.active;
                // self.cancelled = response.data.cancelled;
                // self.pending = response.data.pending;

                window.scrollTo(0, 0);
            }).then(() => {
                self.refreshTable();
            });
        },


        handleSelectDept(selectedFirm) {
                  this.filter.id= selectedFirm.id;
                },









// editmeetingroom(id) {
//     var self = this;
//             axios.post('geteditRoomReservation',{id:id}).then(function (response) { 
//                 self.selected_room = response.data.selected_room;
//                 self.active = response.data.active;
//                 self.completed = response.data.completed;
//                 self.cancelled = response.data.cancelled;
//                 self.rooms = response.data.rooms;
//                 self.pending = response.data.pending;
//                 window.scrollTo(0, 0);
//             });
//         }


    }
}
</script>
